export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[620px] flex items-center pt-16 overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20background%20with%20warm%20amber%20and%20deep%20crimson%20gradient%20lights%2C%20abstract%20film%20reel%20textures%2C%20soft%20bokeh%20effect%2C%20atmospheric%20movie%20theater%20ambiance%2C%20luxurious%20velvet%20curtain%20drapes%2C%20dim%20golden%20spotlights%2C%20rich%20dark%20toned%20composition%2C%20no%20text%2C%20elegant%20cinema%20interior%20mood&width=1800&height=900&seq=hero-bg-cinema-01&orientation=landscape"
          alt="影院氛围背景"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
              每日更新 · 极速观影
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-900 leading-tight mb-3">
              爱丫爱丫影院 — 高清流畅
              <br className="hidden sm:block" />
              秒开不卡顿
            </h1>

            <p className="text-sm md:text-base text-foreground-600 mb-5 font-medium">
              无广告不缓冲，纯粹的观影体验
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              爱丫爱丫影院是一个专注高清流畅观影的免费在线影院平台，覆盖热门电影、经典剧集与高评分电视剧，每日同步更新最新片源。无需注册、无广告干扰，打开即看，支持多设备同步追剧，让每一次观影都畅快无阻，回归纯粹的视觉享受。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-primary-600 font-heading">50+</div>
                <div className="text-xs text-foreground-500">日更新影片</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-primary-600 font-heading">10万+</div>
                <div className="text-xs text-foreground-500">影剧资源库</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-primary-600 font-heading">99.9%</div>
                <div className="text-xs text-foreground-500">播放成功率</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line"></i>
                开始观影
              </a>
              <a
                href="#about"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-secondary-300 text-foreground-700 text-sm font-medium hover:bg-secondary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解平台
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20home%20cinema%20setup%20with%20large%20screen%20displaying%20cinematic%20movie%20scene%2C%20dark%20room%20with%20warm%20amber%20lighting%2C%20comfortable%20seating%2C%20premium%20viewing%20experience%2C%20film%20projector%20light%20rays%2C%20cozy%20atmosphere%2C%20high%20contrast%20rich%20colors%2C%20no%20people%2C%20cinematic%20composition%2C%20warm%20golden%20and%20deep%20red%20tones&width=1200&height=900&seq=hero-visual-cinema-01&orientation=landscape"
                alt="爱丫爱丫影院极速观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                <span className="text-xs text-background-50/90 font-medium">极速加载中...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}